module.exports = __webpack_public_path__ + "static/media/website-logo.ee1e0da6.png";